import { Link } from "react-router-dom";
import { ArrowDown, CalendarCheck, Users, Wallet } from "lucide-react";
import { useSettings } from "@/hooks/queries";

const POINTS = [
  { icon: Users, text: "Hanya rombonganmu" },
  { icon: CalendarCheck, text: "Tanggal pilihan sendiri" },
  { icon: Wallet, text: "Transfer DP / lunas" },
];

export const Hero = () => {
  const { data: s } = useSettings();
  return (
    <section className="relative flex min-h-[94vh] items-end overflow-hidden" data-testid="home-hero">
      <img src="/images/hero.jpg" alt="Pendaki di punggungan gunung berkabut" className="slow-zoom absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/70 to-black/40" />
      <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-36 sm:px-8 md:pb-24">
        <p className="overline-label reveal">Private Trip · Sulawesi Selatan</p>
        <h1
          className="reveal mt-6 max-w-4xl font-display text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-7xl"
          style={{ animationDelay: "120ms" }}
          data-testid="home-hero-title"
        >
          {s?.hero_title || "\u00a0"}
        </h1>
        <p className="reveal mt-6 max-w-xl text-base leading-relaxed text-neutral-300 md:text-lg" style={{ animationDelay: "240ms" }}>
          {s?.hero_subtitle}
        </p>
        <div className="reveal mt-10 flex flex-wrap gap-3" style={{ animationDelay: "360ms" }}>
          <Link to="/#trip" className="btn-gold" data-testid="hero-btn-explore-trips">
            Pilih Trip <ArrowDown className="h-4 w-4" />
          </Link>
          <Link to="/jadwal" className="btn-ghost" data-testid="hero-btn-schedule">
            Lihat Jadwal
          </Link>
        </div>
        <div className="reveal mt-16 grid gap-4 border-t border-white/10 pt-8 sm:grid-cols-3" style={{ animationDelay: "480ms" }}>
          {POINTS.map(({ icon: Icon, text }) => (
            <div key={text} className="flex items-center gap-3 text-sm text-neutral-300">
              <Icon className="h-4 w-4 text-gold" />
              {text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
